import { renderField } from "../helper/functions";

export default function FieldValue({ field, data }) {
  return <div className="w-full">{renderField(field, data)}</div>;
}
